/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { CruxSectionFragment } from "@cosmos/hygraph-schema";
import {
	BackgroundContainer,
	ResponsiveContainer,
	SectionContainer,
	SectionHeading,
	hasContent,
} from "@components/elements";
import { HeadingLevelContext, useCardHeadingOffset } from "@components/context";
import { extractBackgroundContainerProps, extractSectionContainerProps } from "@components/utils/section.utils";
import { VStack } from "@panda/jsx";
import { CruxLinks } from "./CruxLinks.molecule";

export const CruxSection = ({ config, cruxLinks }: CruxSectionFragment): React.JSX.Element | null => {
	const cardOffset = useCardHeadingOffset(hasContent(config?.heading?.title));
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const contentfulLinks = cruxLinks?.filter((cruxLink) => !!cruxLink.label);
	const slicedLinks = contentfulLinks?.slice(0, 4);
	const validContent = Boolean(slicedLinks?.length);
	if (!validHeading && !validContent) return null;
	return (
		<BackgroundContainer {...extractBackgroundContainerProps(config)}>
			<ResponsiveContainer>
				<SectionContainer {...extractSectionContainerProps(config)}>
					<VStack
						alignItems="stretch"
						gap={{ sm: "eds.dimension.48", smDown: "eds.dimension.40" }}
						className="crux-section"
					>
						{validHeading ? <SectionHeading {...config?.heading} /> : null}
						{validContent ? (
							// Links render h3; shift up to h2 when no section h2 title precedes them.
							<HeadingLevelContext.Provider value={{ offset: cardOffset }}>
								<CruxLinks links={slicedLinks} />
							</HeadingLevelContext.Provider>
						) : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
